import { computed, watch } from 'vue';
import { useUrlsStore } from '@/store/urlsStore';
import { useUrlSourcesStore } from '@/store/urlSourcesStore';
import { useActiveUrlStore } from '@/store/activeUrlStore';
import { useNotificationStore } from '@/store/notificationStore';
import { parseSitemapUrls } from '@/helpers/sitemap/parseSitemapUrls';
import { appendCategoryHubs } from '@/helpers/categoryHub/appendCategoryHubs';
import { orderUrlsByProcessingPriority } from '@/helpers/urlProcessingOrder';
import ISitemapUrl from '@/interfaces/IUrl';

export default function useProcessSitemapUrls(): void {
  const urlSourcesStore = useUrlSourcesStore();
  const urlsStore = useUrlsStore();
  const activeUrlStore = useActiveUrlStore();
  const notificationStore = useNotificationStore();

  const sitemapContent = computed(() =>
    urlSourcesStore.getSitemapUrlSource
  );

  watch(
    sitemapContent,
    () => {
      const xml = sitemapContent.value;
      if (!xml) {
        notificationStore.addErrorNotification('Sitemap content is empty.');
        return;
      }

      // Parse sitemap URLs; parseSitemapUrls handles invalid XML internally
      let items = parseSitemapUrls(xml, activeUrlStore.getProvider);
      if (items.length === 0) {
        notificationStore.addErrorNotification('No URLs found in sitemap.');
      }

      items = appendCategoryHubs(items, activeUrlStore.getProvider);

      const ordered = orderUrlsByProcessingPriority(items);
      ordered.forEach((item: ISitemapUrl) => {
        urlsStore.addUrlObject(item);
      });
    },
  );
}
